import React from 'react';
import Modal from 'components/Modal';
import Button from 'components/Button';
import TimesheetApprovalDeclaration from './TimesheetApprovalDeclaration';

export default function TimesheetApproveModal({ declaration, onClose, onConfirm, disabled = false }) {
  return (
    <Modal isOpen header="Approve Timesheet" contentLabel="Approve timesheet" onRequestClose={onClose} contentStyle={{ width: 560, maxWidth: 'calc(100vw - 32px)' }} bodyStyle={{ overflowY: 'auto' }}>
      <div className="timesheet-decision">
        <p>Are you sure you want to approve this timesheet?</p>
        <TimesheetApprovalDeclaration declaration={declaration} />
        <div className="timesheet-decision__actions">
          <Button white className="timesheet-decision__cancel" onClick={onClose}>Cancel</Button>
          <Button className="timesheet-decision__approve" disabled={disabled} onClick={() => { if (!disabled) { onConfirm(); onClose(); } }}>Approve Timesheet</Button>
        </div>
      </div>
    </Modal>
  );
}
